import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, computed, nextTick, onBeforeUnmount } from 'vue';
import { parseError } from '@/v2/shared/lib';


export default /*#__PURE__*/_defineComponent({
  __name: 'Alert',
  props: {
  closeTimer: {
    type: Number,
    default: 7
  }
},
  setup(__props, { expose: __expose }) {

_useCssVars(_ctx => ({
  "49a17cdb": (offset.value)
}))

const alert = ref();
const props = __props;

const timer = ref(props.closeTimer)
const alertType = ref('error');
const msg = ref('');
const nextMessage = ref('');
const nextAlertType = ref('error');
const nextCloseTimer = ref(props.closeTimer);
const offset = computed(() => ( - alert.value?.$el.offsetHeight - 10) + 'px');

__expose({
  show,
  close
});

function close (){
  if(alert.value){
    alert.value.$el.querySelector('.ant-alert-close-icon').click()
    nextMessage.value = ''
  }
}
function show (error: any, type = 'error', closeTimer = props.closeTimer) {
  let message = parseError(error);
  if(message === 'Too Many Attempts.'){
    message = 'Too many attempts.'
  }
  if(alert.value){
    alert.value.$el.querySelector('.ant-alert-close-icon').click()
    nextMessage.value = message
    nextAlertType.value = type;
    nextCloseTimer.value = closeTimer;
  } else {
    msg.value = message;
    alertType.value = type;
    setTimer(closeTimer)
  }
}
async function afterClose(message: string) {
  clearInterval(counter.value)
  timer.value = props.closeTimer
  msg.value = '';
  await nextTick();
  if(message){
    msg.value = message
    alertType.value = nextAlertType.value;
    setTimer(nextCloseTimer.value)
    nextMessage.value = ''
    nextAlertType.value = 'error'
  }
}

const counter = ref()
function setTimer(closeTimer : number = props.closeTimer) {
  if(!closeTimer) return
  timer.value = closeTimer
  counter.value = setInterval(() => {
    if(timer.value === 1){
      close()
    } else {
      timer.value = timer.value - 1
    }
  }, 1000)
}

onBeforeUnmount(() => {
  clearInterval(counter.value)
})


return (_ctx: any,_cache: any) => {
  const _component_a_alert = _resolveComponent("a-alert")!

  return (msg.value)
    ? (_openBlock(), _createBlock(_component_a_alert, _mergeProps({ key: 0 }, _ctx.$attrs, {
        ref_key: "alert",
        ref: alert,
        message: msg.value,
        afterClose: () => afterClose(nextMessage.value),
        type: alertType.value,
        icon: timer.value
      }), null, 16, ["message", "afterClose", "type", "icon"]))
    : _createCommentVNode("", true)
}
}

})